import { useFormik } from "formik";
import React, { useContext, useEffect, useState } from "react";
import { deleteAcctPassword } from "../../components/Validation";
import { confirmPassword, getUserApi } from "../../apis";
import MandatoryLabel from "../../components/common/label";
import { IoEye, IoEyeOff } from "react-icons/io5";
import { InputErrorMessage } from "../../components/errorMessages";
import SimpleButton from "../../components/common/buttons/SimpleButton/SimpleButton";
import UpdatePassword from "../../Pages/ProfileLayout/UpdatePassword";
import toast from "react-hot-toast";
import { AppContext } from "../../appContext";

export default function ChangePasswordSection({ }) {
    const { userDetails } = useContext(AppContext);
    const [passwordType, setPasswordType] = useState('password');
    const [updatePasswordBlock, setUpdatePasswordBlock] = useState(false);
    const [SocialLogin, setSocialLogin] = useState(false);
    const formik = useFormik({
        initialValues: {
            password: '',
        },
        validationSchema: deleteAcctPassword,
        onSubmit: async (values) => {
            console.log(values);
            const { password } = values;
            const payload = {
                userId: userDetails?._id,
                password: password,
            };
            onConfirmPassword(payload);
        },
    });
    const { password } = formik.values;
    const handleChange = (e) => {
        e.preventDefault();
        formik.handleChange(e);
    };
    function handelPasswordType() {
        if (passwordType == 'text') {
            setPasswordType('password');
        } else if (passwordType == 'password') {
            setPasswordType('text');
        }
    }

    const onConfirmPassword = async (payload) => {
        try {
            const res = await confirmPassword(payload);
            if (res.status == 200) {
                toast.success('Set New Password');
                setUpdatePasswordBlock(!updatePasswordBlock);
            } else {
                const message = res.data.error || res.statusText;
                toast.error(message, { id: 'error' });
            }
        } catch (error) {
            console.log(error);
            toast.error(error.response.data?.error);
        }
    };

    const afterPasswordUpdate = () => {
        formik.resetForm();
        setUpdatePasswordBlock(false);
        setSocialLogin(false);
    };
    const fetchData = async () => {
        try {
            const res = await getUserApi();
            if (res.status === 200) {
                if (res.data.Profile?.SocialLogin && res.data.Profile?.SocialLogin == true &&
                    res.data.Profile.password === ""
                ) {
                    setSocialLogin(true);
                } else {
                    setSocialLogin(false);
                }
            }
        } catch (error) {
            console.error(error);
        }
    };
    useEffect(() => {
        fetchData();
    }, []);
    return (
        <form className="pt-[14%] pb-10 max-w-md md:max-w-[80vw] md:pt-[6%] md:ml-[auto] md:mr-[auto] lg:ml-1  px-6 bg-white lg:pt-[0px] lg:pb-[0px] lg:my-7 lg:px-2 marginx_auto custom_x_margin custom_pt_md">
            {
                SocialLogin ?
                    (
                        <UpdatePassword afterPasswordUpdate={afterPasswordUpdate} />
                    ) : (
                        <>
                            {!updatePasswordBlock && (
                                <>
                                    <h2 className="baseText !font-medium max-w-md mb-4">
                                        Enter your current password associated with this account to reset
                                        password{' '}
                                    </h2>
                                    <div className="relative">
                                        <MandatoryLabel title="Current Password" />
                                        <div className="relative">
                                            <input
                                                type={passwordType}
                                                name="password"
                                                className={
                                                    Boolean(formik.touched.password) &&
                                                        Boolean(formik.errors.password)
                                                        ? 'form-control border-danger transparent-input-border'
                                                        : 'form-control transparent-input-border'
                                                }
                                                id="password"
                                                placeholder="Password "
                                                value={formik.values.password}
                                                onChange={handleChange}
                                            />
                                            <div
                                                className="absolute top-1/2 -translate-y-1/2 right-4 p-2 cursor-pointer"
                                                onClick={handelPasswordType}
                                            >
                                                {passwordType == 'password' ? (
                                                    <IoEyeOff />
                                                ) : passwordType == 'text' ? (
                                                    <IoEye />
                                                ) : (
                                                    <></>
                                                )}
                                            </div>
                                        </div>
                                        <InputErrorMessage
                                            error={formik.touched.password && formik.errors.password}
                                        />
                                    </div>
                                </>
                            )}
                            {!updatePasswordBlock && (
                                <>
                                    <SimpleButton
                                        customClass={'bg-accent text-white rounded-md w-full !mt-4 lg:!mt-4'}
                                        buttonType={'primary'}
                                        title={'Continue'}
                                        onClickEvent={formik.handleSubmit}
                                    />
                                </>
                            )}
                            {updatePasswordBlock && (
                                <UpdatePassword afterPasswordUpdate={afterPasswordUpdate} />
                            )}
                        </>
                    )

            }

        </form>

    )
}